import { render } from "./ProfileImageCatalogueComponent.vue?vue&type=template&id=58a52ad1&scoped=true"
import script from "./ProfileImageCatalogueComponent.vue?vue&type=script&lang=js"
export * from "./ProfileImageCatalogueComponent.vue?vue&type=script&lang=js"

import "./ProfileImageCatalogueComponent.vue?vue&type=style&index=0&id=58a52ad1&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a52ad1"]])

export default __exports__